<template>
  <div>
    <div class="wrapper">
      <div class="step">
        <div class="step-icon-wrapper">
          <div class="step-blank"></div>
          <div class="step-icon"
            :class="{'step-green' : qualification.hoCompleteDate, 'step-red': !qualification.hoCompleteDate}">1</div>
          <div class="step-line-right"></div>
        </div>
        <div class="step-title">HO Qual Complete</div>
        <div class="step-date">{{getDate(qualification.hoCompleteDate)}}</div>
      </div>
      <div class="divider"></div>
      <div class="step">
        <div class="step-icon-wrapper">
          <div class="step-line-left"></div>
          <div class="step-icon"
            :class="{'step-green' : qualification.transferedDate, 'step-red': !qualification.transferedDate}">2</div>
          <div class="step-line-right"></div>
        </div>
        <div class="step-title">Passed to director </div>
        <div class="step-date">{{getDate(qualification.transferedDate)}}</div>
      </div>
      <div class="divider"></div>
      <div class="step">
        <div class="step-icon-wrapper">
          <div class="step-line-left"></div>
          <div class="step-icon"
          :class="{'step-green' : qualification.contractSentDate, 'step-red': !qualification.contractSentDate}">3</div>
          <div class="step-line-right"></div>
        </div>
        <div class="step-title">Contract Sent </div>
        <div class="step-date">{{getDate(qualification.contractSentDate)}}</div>
      </div>
      <div class="divider"></div>
      <div class="step">
        <div class="step-icon-wrapper">
          <div class="step-line-left"></div>
          <div class="step-icon"
          :class="{'step-green' : qualification.clientWonDateTime, 'step-red': !qualification.clientWonDateTime}">4</div>
          <div class="step-blank"></div>
        </div>
        <div class="step-title">Client</div>
        <div class="step-date">{{getDate(qualification.clientWonDateTime)}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns'

export default {
  components: {},
  props: {
    qualification: Object,
  },
  data() {
    return {};
  },
  methods: {
    getDate(date) {
      if(date == null) return "";

      return format(new Date(date), "dd/MM/yyyy HH:mm")
    },
  },
};
</script>


<style scoped>
.wrapper {
  display: flex;
  margin-bottom: 24px;
}

.step-icon-wrapper {
  display: flex;
  min-width: 100px;
}

.step-icon {
  border-radius: 20px;
  background-color: red;
  color: white;
  width: 24px;
  text-align: center;
}

.step-line-left,
.step-line-right,
.step-blank {
  flex: auto;
}

.step-line-left {
  margin-right: 5px;
}

.step-line-right {
  margin-left: 5px;
}

.step-line-left,
.step-line-right {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  margin-top: 11px;
}

.divider {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  flex: auto;
  margin-top: 11px;
}

.step-date, .step-title {
  text-align: center;
}

.step-red {
  background-color: red;
}

.step-green {
  background-color: #28a745
}
</style>

